'use client'

import React, { useMemo } from 'react'

import { useHolidayContext } from '@/src/contexts'
import { buildHolidayNavTabs } from '@/src/utils/holidays'
import { selectRefundTimeline } from '@/src/utils/holidays/parseRefundTimeline'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import HolidayPackageDesktopPage from './package'

const HolidayPackageDesktopContainer = ({ domainCountry }: { domainCountry: string }) => {
    const { packageData } = useHolidayContext()

    const navTabs = useMemo(() => (packageData ? buildHolidayNavTabs(packageData.sections) : []), [packageData])

    // Resolved here, not per section: which schedule wins depends on the whole document.
    const refundTimeline = useMemo(
        () => (packageData ? selectRefundTimeline(packageData.sections) : null),
        [packageData]
    )

    if (!packageData) return null

    return (
        <ErrorBoundaryWrapper identifier="holidays-package-desktop">
            <HolidayPackageDesktopPage
                holidayPackage={packageData}
                navTabs={navTabs}
                collectionLabel={packageData.collectionLabel}
                refundTimeline={refundTimeline}
                domainCountry={domainCountry}
            />
        </ErrorBoundaryWrapper>
    )
}

export default HolidayPackageDesktopContainer
